// Function to help the navigation

export default {
    methods: {
        goBack() { window.history.go(-1) },
    }
}